import { defineComponent, provide, openBlock, createElementBlock, renderSlot } from 'vue';
import { UiFormPropsOption } from './index.mjs';
import { useComposable } from './src/composable.mjs';
import { UiFormEmitterKey, UiFormDataKey, UiFormRulesKey } from '../../../constants/index.mjs';

const __default__ = defineComponent({ name: "UiForm" });
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: UiFormPropsOption,
  setup(__props, { expose: __expose }) {
    const define = __props;
    const { refs, methods, emitter } = useComposable(define);
    const { reset, clear, validator } = methods;
    const { form } = refs;
    provide(UiFormEmitterKey, emitter);
    provide(UiFormDataKey, define.data);
    provide(UiFormRulesKey, define.rules);
    ;
    __expose({ reset, clear, validator });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(
        "form",
        {
          class: "ui-form",
          ref_key: "form",
          ref: form
        },
        [
          renderSlot(_ctx.$slots, "default")
        ],
        512
        /* NEED_PATCH */
      );
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
